"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixText = fixText;
const tex_syntax_1 = require("./tex-syntax");
function fixText(tex) {
    return tex.replace(new RegExp(`\\\\text\\s*(\\\\(${tex_syntax_1.color})${(0, tex_syntax_1.arg)(2)})`, "g"), "\\text{$1}");
}
